import {
  LANG_CODE_VIETNAMESE,
  TYPE_INFORMATION,
  TYPE_NOTIFICATION,
  READ_FLAG_UN_READ,
  READ_FLAG_READ,
  DISPLAY_INFO,
  NO_ROOM_JP_EN,
  NO_SECTION_JP_EN,
  LANG_CODE_JAPANESE
} from '@/common/constants';

const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const groupByCategory = groupBy('occupation_group_code');

const getData = (obj, nameEN, lang) => {
  const nameVN = nameEN + '_vn';
  if (typeof obj !== 'undefined') {
    obj.map((ele) => {
      ele.name_convert =
        lang === LANG_CODE_JAPANESE ? ele[nameEN] : ele[nameVN];
      return {
        ...ele
      };
    });
  }

  return Object.assign([], obj);
};

const getEventByLang = (data, lang) => {
  if (typeof data != 'undefined' && data != null) {
    const obj = {};
    Object.keys(data).map((key) => {
      if (lang === LANG_CODE_VIETNAMESE) {
        if (key.includes('_vn') || key.includes('company_name_en')) {
          const keyConvert = key.substring(0, key.length - 3);

          obj[keyConvert] = data[key];
        } else {
          obj[key] = data[key];
        }
      } else {
        obj[key] = data[key];
      }
    });

    return Object.assign({}, obj);
  }

  return {};
};

const getObjectByLang = (data, lang) => {
  if (typeof data != 'undefined') {
    const dataConvert = data.map((ele) => {
      const obj = {};

      Object.keys(ele).map((key) => {
        if (lang === LANG_CODE_VIETNAMESE) {
          if (key.includes('_vn')) {
            const keyConvert = key.substring(0, key.length - 3);

            obj[keyConvert] = ele[key];
          } else {
            obj[key] = ele[key];
          }
        } else {
          obj[key] = ele[key];
        }
      });

      return Object.assign({}, obj);
    });

    return Object.assign([], dataConvert);
  }

  return [];
};

const convertCompanyCareerToArrayGroup = (data) => {
  let arr = [];

  const career_1 = {};
  const career_2 = {};
  const career_3 = {};
  const career_4 = {};

  Object.keys(data).map((key) => {
    const _index = key.indexOf('_');

    const keyConvert = key.substring(0, _index);

    if (!key.includes('_vn')) {
      if (key.includes('_1') && !key.includes('_10')) {
        career_1[keyConvert] = data[key];
      }

      if (key.includes('_3')) {
        career_2[keyConvert] = data[key];
      }

      if (key.includes('_5')) {
        career_3[keyConvert] = data[key];
      }

      if (key.includes('_10')) {
        career_4[keyConvert] = data[key];
      }
    }
  });

  arr = {
    career_1,
    career_2,
    career_3,
    career_4
  };

  return arr;
};

// thực hiện việc lấy ra mảng info để hiển thị
const getDisplayInformation = (state) => {
  const newArrayInformation = [];

  const { m_event } = state.eventMaster;

  if (typeof m_event !== 'undefined' && m_event !== null) {
    if (state.profile !== null) {
      const { information = [] } = state.profile;

      if (
        typeof information !== 'undefined' &&
        information !== null &&
        information.length !== 0
      ) {
        information.d_info.map((info) => {
          const checkHas = information.hidden_info.filter(
            (ele) => info.id === ele.id
          );

          const checkUnread = information.unread_notice.filter(
            (ele) => info.id === ele.id
          );

          if (checkHas.length === 0) {
            info.type_notification = TYPE_INFORMATION;
            info.sender = info.display_name;
            info.created_at = info.display_time_from;
            info.read_flag =
              checkUnread.length > 0 ? READ_FLAG_UN_READ : READ_FLAG_READ;
            info.display_flag = DISPLAY_INFO;
            newArrayInformation.push(info);
            return info;
          }

          return info;
        });
      }
    }
  }

  return newArrayInformation;
};

const getters = {
  getCurrentLanguage: (state) => {
    return state.lang;
  },

  getConstants: (state) => {
    return state.constants;
  },

  getCLanguage: (state) => {
    const lang = state.lang;

    const { c_language } = state.constants;

    return getData(c_language, 'lang_name', lang);
  },

  getCSystem: (state) => {
    let { c_system } = state.constants;

    if (typeof c_system !== 'undefined') {
      if (typeof c_system == 'object') {
        c_system = Object.values(c_system);
        if (c_system.length > 0) {
          return c_system[0];
        }
      }
    }

    return null;
  },

  getCStudyStatus: (state) => {
    const lang = state.lang;

    const { c_study_status } = state.constants;

    return getData(c_study_status, 'study_status_name', lang);
  },

  getCWorkStatus: (state) => {
    const lang = state.lang;

    const { c_work_status } = state.constants;

    return getData(c_work_status, 'work_status_name', lang);
  },

  getCRecruitingTarget: (state) => {
    const lang = state.lang;

    const { c_recruiting_target } = state.constants;

    return getData(c_recruiting_target, 'recruiting_target_name', lang);
  },

  getCJapaneseLevel: (state) => {
    const lang = state.lang;

    const { c_japanese_level } = state.constants;

    return getData(c_japanese_level, 'japanese_level_name', lang);
  },

  getCEnglishLevel: (state) => {
    const lang = state.lang;

    const { c_english_level } = state.constants;

    return getData(c_english_level, 'english_level_name', lang);
  },

  getCWorkContractType: (state) => {
    const lang = state.lang;

    const { c_work_contract_type } = state.constants;

    return getData(c_work_contract_type, 'work_contract_type_name', lang);
  },

  getCTimeZone: (state) => {
    const lang = state.lang;

    const { c_time_zone } = state.constants;

    return getData(c_time_zone, 'time_zone_name', lang);
  },

  getEventData: (state) => {
    const lang = state.lang;

    if (state.eventMaster !== null) {
      const { m_event } = state.eventMaster;

      return getEventByLang(m_event, lang);
    }
    return null;
  },

  getMPrivacyPolicy: (state) => {
    let { m_privacy_policy } = state.eventMaster;
    let data = null;
    if (typeof m_privacy_policy !== 'undefined') {
      if (typeof m_privacy_policy == 'object') {
        m_privacy_policy = Object.values(m_privacy_policy);
      }
      m_privacy_policy.map((ele) => {
        data = ele.privacy_policy;
      });
    }

    return data;
  },

  getMUniversity: (state) => {
    const lang = state.lang;
    let { m_university } = state.eventMaster;

    if (typeof m_university !== 'undefined') {
      if (typeof m_university == 'object') {
        m_university = Object.values(m_university);
      }
    }

    return getData(m_university, 'university_name', lang);
  },

  getMFaculty: (state) => {
    const lang = state.lang;
    let { m_faculty } = state.eventMaster;

    if (typeof m_faculty !== 'undefined') {
      if (typeof m_faculty == 'object') {
        m_faculty = Object.values(m_faculty);
      }
    }

    return getData(m_faculty, 'faculty_name', lang);
  },

  getRegistrationPeriodStatus: (state) => {
    return state.registrationPeriodStatus;
  },

  getMSkillType: (state) => {
    const lang = state.lang;

    let { m_skill_type } = state.eventMaster;

    if (typeof m_skill_type == 'object') {
      m_skill_type = Object.values(m_skill_type);
    }

    return getData(m_skill_type, 'skill_type_name', lang);
  },

  getMSkill: (state) => {
    const lang = state.lang;

    let { m_skill } = state.eventMaster;

    if (typeof m_skill == 'object') {
      m_skill = Object.values(m_skill);
    }

    return getData(m_skill, 'skill_name', lang);
  },

  getMSkillFromSkillTypeCode: (state, skill_type_code) => {
    const lang = state.lang;

    let { m_skill } = state.eventMaster;

    if (typeof m_skill == 'object') {
      m_skill = Object.values(m_skill);
    }

    const data = getData(m_skill, 'skill_name', lang);

    data.filter((ele) => ele.skill_type_code === skill_type_code);

    return data;
  },

  getMWorkLocationApplicant: (state) => {
    const lang = state.lang;

    let { m_work_location_applicant } = state.eventMaster;

    if (typeof m_work_location_applicant == 'object') {
      m_work_location_applicant = Object.values(m_work_location_applicant);
    }

    return getData(m_work_location_applicant, 'work_location_name', lang);
  },
  getArea: (state) => {
    let { m_area } = state.eventMaster;

    if (typeof m_area == 'object') {
      m_area = Object.values(m_area);
    }

    return m_area || [];
  },

  getHometown: (state) => {
    let { m_hometown } = state.eventMaster;

    if (typeof m_hometown == 'object') {
      m_hometown = Object.values(m_hometown);
    }

    return m_hometown || [];
  },

  getMWorkLocationCompany: (state) => {
    const lang = state.lang;

    let { m_work_location_company } = state.eventMaster;

    if (typeof m_work_location_company == 'object') {
      m_work_location_company = Object.values(m_work_location_company);
    }

    return getData(m_work_location_company, 'work_location_name', lang);
  },

  getInputExample: (state) => {
    let { m_input_example } = state.eventMaster;

    if (typeof m_input_example == 'object') {
      m_input_example = Object.values(m_input_example);
    }

    return m_input_example || [];
  },

  getMIndustryType: (state) => {
    const lang = state.lang;

    let { m_industry_type } = state.eventMaster;

    if (typeof m_industry_type == 'object' && m_industry_type !== null) {
      m_industry_type = Object.values(m_industry_type);
    }

    return getData(m_industry_type, 'industry_type_name', lang);
  },

  getMOccupationType: (state) => {
    const lang = state.lang;

    let { m_occupation_type_applicant } = state.eventMaster;

    if (typeof m_occupation_type_applicant == 'object') {
      m_occupation_type_applicant = Object.values(m_occupation_type_applicant);
    }

    const dataFromLang = getData(
      m_occupation_type_applicant,
      'occupation_type_name',
      lang
    );

    return groupByCategory(dataFromLang);
  },

  getMOccupationTypeCompany: (state) => {
    const lang = state.lang;

    let { m_occupation_type_company } = state.eventMaster;

    if (typeof m_occupation_type_company == 'object') {
      m_occupation_type_company = Object.values(m_occupation_type_company);
    }

    return getData(m_occupation_type_company, 'occupation_type_name', lang);
  },

  getMOccupationTypeDefault: (state) => {
    const lang = state.lang;

    let { m_occupation_type_applicant } = state.eventMaster;

    if (typeof m_occupation_type_applicant == 'object') {
      m_occupation_type_applicant = Object.values(m_occupation_type_applicant);
    }

    return getData(m_occupation_type_applicant, 'occupation_type_name', lang);
  },

  getMOccupationTypeNoGroup: (state) => {
    const lang = state.lang;

    let { m_occupation_type_applicant } = state.eventMaster;

    if (typeof m_occupation_type_applicant == 'object') {
      m_occupation_type_applicant = Object.values(m_occupation_type_applicant);
    }

    const dataFromLang = getData(
      m_occupation_type_applicant,
      'occupation_type_name',
      lang
    );

    return dataFromLang;
  },

  getStatusCheckEvent: (state) => {
    return state.checkEvent;
  },

  getStatusCheckAuth: (state) => {
    return state.checkAuth;
  },

  getStatusCheckAuthReceptionist: (state) => {
    return state.checkAuthReceptionist;
  },

  getFullPath: (state) => {
    if (state.fullPath !== null) {
      const { fullPath } = state.fullPath;
      if (typeof fullPath !== 'undefined') {
        return fullPath;
      }
    }
    return null;
  },

  getRegisterStatus: (state) => {
    return state.registerStatus;
  },

  // getCompanyData: state => {
  //   return state.company;
  // },
  getCompanyData: (state) => {
    let newArr1 = [];
    let newArr2 = [];
    let reListCompany = [];
    let reFavoriteCompany = [];
    const lang = state.lang;
    if (state.company !== null) {
      const { listCompany = [], favoriteCompany = [] } = state.company;
      if (listCompany !== null) {
        reListCompany = listCompany.map((company) => {
          newArr1 = company.information;
          if (newArr1 !== null) {
            const data1 = getEventByLang(newArr1, lang);
            return Object.assign({}, { ...company, information: data1 });
          }
        });
      }
      if (favoriteCompany !== null) {
        reFavoriteCompany = favoriteCompany.map((company) => {
          newArr2 = company.information;
          if (newArr2 !== null) {
            const data2 = getEventByLang(newArr2, lang);
            return Object.assign({}, { ...company, information: data2 });
          }
        });
      }

      return Object.assign(
        {},
        { listCompany: reListCompany, favoriteCompany: reFavoriteCompany }
      );
    }
    return null;
  },

  getFavoriteCompanyData: (state) => {
    return state.company.favoriteCompany;
  },

  getCompanyDetail: (state) => {
    return state.companyDetail;
  },
  getCompanyInterviewNote: (state) => {
    if (state.companyDetail !== null) {
      const { companyInterviewNote } = state.companyDetail;
      return companyInterviewNote;
    }
    return null;
  },
  getCompanyInfoDetail: (state) => {
    const lang = state.lang;
    if (state.companyDetail !== null) {
      const { detail } = state.companyDetail;
      if (typeof detail !== 'undefined' && detail !== null) {
        const { d_company } = detail;
        if (typeof d_company !== 'undefined' && d_company !== null) {
          const data = getEventByLang(d_company, lang);

          return data;
        }
      }
    }

    return null;
  },

  getPreviewCompanyStatus: (state) => {
    return state.previewCompanyStatus;
  },

  // basic infomation page
  getBasicInfomation: (state) => {
    if (state.profile !== null) {
      const { applicant } = state.profile;

      if (typeof applicant.data !== 'undefined') {
        return Object.assign({}, applicant.data);
      }
    } else {
      return null;
    }
  },

  getEntryInfomation: (state) => {
    if (state.profile !== null) {
      const { applicant_entry } = state.profile;

      if (typeof applicant_entry !== 'undefined') {
        return Object.assign({}, applicant_entry);
      }
    } else {
      return null;
    }
  },

  getRegisterResult: (state) => {
    return state.registerResult;
  },

  getRegisterResultStatus: (state) => {
    return state.registerResultStatus;
  },

  getLang: (state) => {
    return state.lang;
  },

  getProfile: (state) => {
    return state.profile;
  },

  getUnauthorized: (state) => {
    return state.getUnauthorized;
  },

  getDataInformationAndNotification: (state) => {
    const newArrayInformationAndNotification = [];

    const { m_event } = state.eventMaster;

    if (typeof m_event !== 'undefined' && m_event !== null) {
      if (state.profile !== null) {
        const { notification } = state.profile;
        // get array display information
        const information = getDisplayInformation(state);

        if (information) {
          information.map((ele) => {
            newArrayInformationAndNotification.push(ele);
            return ele;
          });
        }

        if (
          typeof notification !== 'undefined' &&
          notification !== null &&
          notification.length !== 0
        ) {
          notification.map((ele) => {
            ele.type_notification = TYPE_NOTIFICATION;
            ele.sender = m_event.notification_display_name;
            newArrayInformationAndNotification.push(ele);
            return ele;
          });
        }
      }
    }

    // sort
    newArrayInformationAndNotification.sort((mail, otherMail) => {
      // conver 'yyyy-mm-dd hh:mm:ss' -> 'yyyy/mm/dd hh:mm:ss'
      // format 'yyyy-mm-dd hh:mm:ss' not run in ie
      const mailA = mail.created_at.replace(/-/g, '/');
      const mailB = otherMail.created_at.replace(/-/g, '/');
      return new Date(mailB) - new Date(mailA);
    });

    return newArrayInformationAndNotification;
  },

  getJobDescriptionFromDetail: (state) => {
    if (state.companyDetail !== null) {
      const detail = state.companyDetail.detail;
      if (typeof detail != 'undefined' && detail != null) {
        const { d_company_job_description } = detail;

        if (
          d_company_job_description !== null &&
          typeof d_company_job_description !== 'undefined'
        ) {
          const lang = state.lang;

          return getEventByLang(d_company_job_description, lang);
        }

        return null;
      }
    }

    return null;
  },

  getCompanyCareerFromDetail: (state) => {
    const { detail } = state.companyDetail;

    if (detail !== null && typeof detail !== 'undefined') {
      const { d_company_career } = detail;

      if (
        d_company_career !== null &&
        typeof d_company_career !== 'undefined'
      ) {
        const lang = state.lang;

        const data = getEventByLang(d_company_career, lang);

        return convertCompanyCareerToArrayGroup(data);
      }
      return null;
    }

    return null;
  },

  getCompanyPrFromDetail: (state) => {
    const { detail } = state.companyDetail;
    if (detail !== null && typeof detail !== 'undefined') {
      const { d_company_promotion } = detail;

      if (
        d_company_promotion !== null &&
        typeof d_company_promotion !== 'undefined'
      ) {
        const lang = state.lang;

        return getEventByLang(d_company_promotion, lang);
      }
      return null;
    }
    return null;
  },

  getArrayCompanyFavoriteId: (state) => {
    const arrayFavoriteId = [];
    if (typeof state.company !== 'undefined') {
      const { favoriteCompany } = state.company;

      if (
        typeof favoriteCompany !== 'undefined' &&
        favoriteCompany.length > 0
      ) {
        favoriteCompany.map((company) => {
          arrayFavoriteId.push(company.id);
        });
      }

      return arrayFavoriteId;
    }
  },

  getGoogleAnalytic: (state) => {
    const { m_event } = state.eventMaster;
    if (typeof m_event !== 'undefined') {
      const { google_analytics_id } = m_event;
      if (google_analytics_id !== null) {
        return google_analytics_id;
      }
    }
    return null;
  },

  getScoutMail: (state) => {
    // let lang = state.lang;
    const profile = state.profile;

    if (profile !== null && typeof profile !== 'undefined') {
      const { scout_mail } = profile;
      // if(typeof scout_mail !== 'undefined' && scout_mail !== null) {
      // 	return getScoutMailByLang(scout_mail, lang);
      // }

      return Object.assign([], scout_mail);
    }

    return [];
  },

  getBaseUrl: (state) => {
    return state.baseUrl;
  },

  getEmailCheck: (state) => {
    return state.emailCheck;
  },

  getApplicantCompanyInterview: (state) => {
    return state.applicantCompanyInterview;
  },

  getApplicantInterviewStatus: (state) => {
    return state.applicantInterviewStatus;
  },

  getEventInterviewNote: (state) => {
    return state.eventInterviewNote;
  },

  getCheckInData: (state) => {
    return state.checkInData;
  },

  getDataListCheckInReception: (state) => {
    if (state.listCheckInReception !== null) {
      return state.listCheckInReception.list;
    }
    return [];
  },

  getMSurveyTemplate: (state) => {
    let { m_survey_template } = state.eventMaster;

    if (typeof m_survey_template !== 'undefined') {
      if (typeof m_survey_template == 'object') {
        m_survey_template = Object.values(m_survey_template);
        if (m_survey_template.length > 0) {
          return m_survey_template[0];
        }
      }
    }

    return null;
  },

  getNotiArray: (state) => {
    const newArrayInformationAndNotification = [];

    const { m_event } = state.eventMaster;

    if (typeof m_event !== 'undefined' && m_event !== null) {
      if (state.profile !== null) {
        const { noti } = state.profile;
        // get array display information

        if (noti) {
          const information = noti.unread_info;
          const notification = noti.unread_notification_applicant;

          if (information) {
            information.map((ele) => {
              newArrayInformationAndNotification.push(ele);
              return ele;
            });
          }

          if (
            typeof notification !== 'undefined' &&
            notification !== null &&
            notification.length !== 0
          ) {
            notification.map((ele) => {
              ele.type_notification = TYPE_NOTIFICATION;
              ele.sender = m_event.notification_display_name;
              newArrayInformationAndNotification.push(ele);
              return ele;
            });
          }
        }
      }
    }

    // sort
    newArrayInformationAndNotification.sort((mail, otherMail) => {
      // conver 'yyyy-mm-dd hh:mm:ss' -> 'yyyy/mm/dd hh:mm:ss'
      // format 'yyyy-mm-dd hh:mm:ss' not run in ie
      const mailA = mail.created_at.replace(/-/g, '/');
      const mailB = otherMail.created_at.replace(/-/g, '/');
      return new Date(mailB) - new Date(mailA);
    });

    return newArrayInformationAndNotification;
  },

  getScoutMailArray: (state) => {
    const profile = state.profile;

    if (profile !== null && typeof profile !== 'undefined') {
      const { noti } = profile;
      if (noti && noti.unread_scout_mail.length > 0) {
        return Object.assign([], noti.unread_scout_mail);
      }
    }

    return [];
  },
  getStatusEvent: (state) => {
    return state.checkEvent.success;
  },

  getLandingPageLink: (state) => {
    return state.landingPageLinkData;
  },

  getEventScheduleNote: (state) => {
    const lang = state.lang;

    if (state.dataEventSchedule !== null) {
      const { eventScheduleNote } = state.dataEventSchedule;

      if (typeof eventScheduleNote !== 'undefined') {
        return getEventByLang(eventScheduleNote, lang);
      }
    } else {
      return null;
    }
  },

  getEventScheduleDate: (state) => {
    const lang = state.lang;

    if (state.dataEventSchedule !== null) {
      const { eventScheduleDate } = state.dataEventSchedule;

      if (typeof eventScheduleDate !== 'undefined') {
        const { eventScheduleDate } = state.dataEventSchedule;

        if (typeof eventScheduleDate !== 'undefined') {
          return getObjectByLang(Object.values(eventScheduleDate), lang);
        }
      }
    } else {
      return null;
    }
  },

  getEventScheduleRoom: (state) => {
    const lang = state.lang;

    if (state.dataEventSchedule !== null) {
      const { eventScheduleRoom, hasEventScheduleRoomNull } =
        state.dataEventSchedule;

      if (typeof eventScheduleRoom !== 'undefined') {
        const dataRooms = getObjectByLang(
          Object.values(eventScheduleRoom),
          lang
        );
        if (hasEventScheduleRoomNull === true && dataRooms.length > 0) {
          dataRooms.unshift({ id: null, event_schedule_room: NO_ROOM_JP_EN });
        }

        return dataRooms;
      }
    } else {
      return null;
    }
  },

  getEventScheduleSection: (state) => {
    const lang = state.lang;

    if (state.dataEventSchedule !== null) {
      const { eventScheduleSection, eventSchedule } = state.dataEventSchedule;

      if (
        typeof eventScheduleSection !== 'undefined' &&
        typeof eventScheduleSection !== 'undefined'
      ) {
        const sectionFromLang = getEventByLang(eventScheduleSection, lang);

        if (typeof sectionFromLang == 'object') {
          const sectionFromLangArr = Object.values(sectionFromLang);

          // check has no section eventSchedule
          const isExistedNoSection = Object.keys(eventSchedule).includes('');

          if (isExistedNoSection) {
            sectionFromLangArr.unshift({
              id: null,
              event_schedule_section: NO_SECTION_JP_EN
            });
          }

          const data = sectionFromLangArr.map((section) => {
            let scheduleArr = [];

            Object.keys(eventSchedule).map((key) => {
              if (section.id == key || (!key && !section.id)) {
                const eventScheduleConvert =
                  key === null ? eventSchedule[' '] : eventSchedule[key];

                const data = getObjectByLang(
                  Object.values(eventScheduleConvert),
                  lang
                );

                const urlOfSchedule = [];

                data.forEach((schedule, indexSchedule) => {
                  if (schedule.urlArray && schedule.urlArray.length > 0) {
                    schedule.urlArray.forEach((url, indexSchedule) => {
                      const objUrl = Object.assign(
                        {},
                        {
                          ...url,
                          event_schedule_date: schedule.event_schedule_date_id,
                          event_schedule_time_from:
                            schedule.event_schedule_time_from,
                          event_schedule_time_to:
                            schedule.event_schedule_time_to,
                          event_schedule_content:
                            schedule.event_schedule_content,
                          event_schedule_content_vn:
                            schedule.event_schedule_content_vn,
                          is_top:
                            indexSchedule == 0 && indexSchedule == 0
                              ? true
                              : false
                        }
                      );

                      urlOfSchedule.push(objUrl);
                    });
                  } else {
                    const objUrl = Object.assign(
                      {},
                      {
                        event_schedule_date: schedule.event_schedule_date_id,
                        event_schedule_time_from:
                          schedule.event_schedule_time_from,
                        event_schedule_time_to: schedule.event_schedule_time_to,
                        event_schedule_content: schedule.event_schedule_content,
                        event_schedule_content_vn:
                          schedule.event_schedule_content_vn,
                        is_top: true,
                        url: '',
                        company_name: '',
                        note: ''
                      }
                    );

                    urlOfSchedule.push(objUrl);
                  }
                });

                scheduleArr = Object.assign([], urlOfSchedule);
              }
            });
            return Object.assign({}, { ...section, scheduleArr });
          });

          return data;
        }
      }
    } else {
      return null;
    }
  },

  getEventSchedule: (state) => {
    const lang = state.lang;

    if (state.dataEventSchedule !== null) {
      const { eventSchedule } = state.dataEventSchedule;

      if (typeof eventSchedule !== 'undefined') {
        return getEventByLang(eventSchedule, lang);
      }
    } else {
      return null;
    }
  },

  getMIndustryTypeLandingPage: (state) => {
    const lang = state.lang;

    let { mIndustryType } = state.landingPageLinkData;

    if (typeof mIndustryType == 'object' && mIndustryType !== null) {
      mIndustryType = Object.values(mIndustryType);
    }

    return getData(mIndustryType, 'industry_type_name', lang);
  },
  getMWorkLocationLandingPage: (state) => {
    const lang = state.lang;

    let { mWorkLocationCompany } = state.landingPageLinkData;

    if (
      typeof mWorkLocationCompany == 'object' &&
      mWorkLocationCompany !== null
    ) {
      mWorkLocationCompany = Object.values(mWorkLocationCompany);
    }

    return getData(mWorkLocationCompany, 'work_location_name', lang);
  },

  getMTemplate: (state) => {
    const { template } = state.eventMaster;
    return template && template;
  },
  getMEvent: (state) => {
    return state.eventMaster.m_event;
  },
  getEvenMaster: (state) => {
    return state.eventMaster;
  },
  getHasEventScheduleRoomNullData: (state) => {
    if (state.dataEventSchedule) {
      return state.dataEventSchedule.hasEventScheduleRoomNull;
    } else return null;
  },

  getMEventLandingPage: (state) => {
    return getEventByLang(state.landingPageLinkData.mEvent, state.lang);
  },
  getLPEventOutline: (state) => {
    const lang = state.lang;

    const { mLPEventOutline } = state.landingPageLinkData;

    console.log(mLPEventOutline);

    return getEventByLang(mLPEventOutline, lang);
  },

  getTemplate: (state) => {
    return state;
  },

  getDataLanguage: (state) => {
    if (typeof state.dataLanguage !== 'undefined') {
      return state.dataLanguage;
    }
    return null;
  },

  getDefaultLang: (state) => {
    if (typeof state.defaultLanguage !== 'undefined') {
      return state.defaultLanguage;
    }
    return null;
  },

  getLangDefaultTitle: (state) => {
    return state.langTitle;
  },

  getContractId: (state) => {
    return state.contract_id;
  },

  getEventCode: (state) => {
    return state.event_code;
  }
};
export default getters;
